import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  makeUrl,
  useAppLocation,
  useAnalytics,
  useAppNavigate,
  Category,
  StoreMetadata,
  DBProduct,
  CategoriesResponseItem,
} from "@commons-monorepo/index";
import { MainSidebarMenuEvents } from "./main-header-sidebar-menu.events";

export const useMainHeaderSidebarMenu = ({
  templateId,
  storeMetadata,
  data,
}: {
  data: {
    avatarProfile: string;
    cartProducts: DBProduct[];
    categories: CategoriesResponseItem[];
    isMobile: boolean;
    storeMetadata: StoreMetadata;
    user?: any;
  };
  templateId: string;
  storeMetadata: StoreMetadata;
}) => {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const { pathname } = useAppLocation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const isLoggedIn = data?.user !== null;
  const ownerId = storeMetadata?.configuration?.ownerId;
  const storeUserPathName = storeMetadata?.userNetwork.urlSummer || ownerId;
  const [categoriesShowList, setCategoriesShowList] = useState(false);
  const [categorySelected, setCategorySelected] = useState<string>();
  const [showHeaderDetail, setShowHeaderDetail] = useState(false);
  const handleShowLogin = useCallback(() => {
    const to = `${pathname}/${makeUrl(pathname, "iniciar-sesion")}`;
    navigate(to, {
      relative: "path",
    });
  }, [pathname]);
  const SHOW_LOGIN_BUTTON = false;

  const handleShowStoreInfo = useCallback(() => {
    const to = `${pathname}/${makeUrl(pathname, "contactanos")}`;
    navigate(to, {
      relative: "path",
    });
  }, [pathname]);

  const handleCloseSession = (): void => {
    localStorage.clear();
    location.reload();
  };

  const handleClickCategoriesList = () => {
    if (!categoriesShowList) {
      logEvent(MainSidebarMenuEvents.SelectMenuCategories, {
        Template_id: templateId,
      });
    }
    setCategoriesShowList(!categoriesShowList);
  };

  const handleSelectCategory = (category: Category) => {
    logEvent(MainSidebarMenuEvents.SelectMenuCategory, {
      Template_id: templateId,
      category_name: category.name,
    });
  };

  const handleShowSubcategories = (category: Category) => {
    setCategorySelected(
      categorySelected !== category.id ? category.id : undefined,
    );
  };

  return {
    t,
    SHOW_LOGIN_BUTTON,
    logEvent,
    isLoggedIn,
    handleShowLogin,
    handleCloseSession,
    handleShowStoreInfo,
    categoriesShowList,
    handleClickCategoriesList,
    categorySelected,
    handleSelectCategory,
    handleShowSubcategories,
    storeUserPathName,
    data,
  };
};
